import { render, staticRenderFns } from "./devicereturn.vue?vue&type=template&id=32ba9cdb&scoped=true"
import script from "./devicereturn.vue?vue&type=script&lang=js"
export * from "./devicereturn.vue?vue&type=script&lang=js"
import style0 from "./devicereturn.vue?vue&type=style&index=0&id=32ba9cdb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ba9cdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ba9cdb')) {
      api.createRecord('32ba9cdb', component.options)
    } else {
      api.reload('32ba9cdb', component.options)
    }
    module.hot.accept("./devicereturn.vue?vue&type=template&id=32ba9cdb&scoped=true", function () {
      api.rerender('32ba9cdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/return/devicereturn.vue"
export default component.exports